export { default } from './LessonAttempts';



// WEBPACK FOOTER //
// ./src/components/DataCentre/LessonAttempts/index.ts